import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import "./LetStarted.scss";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Step from "../../components/step/Step";
import Form from "react-bootstrap/Form";
import euro from "../../assets/images/Euro.svg";
import chf from "../../assets/images/chf.svg";
import dollor from "../../assets/images/Dollor.svg";
import Button from "react-bootstrap/Button";
import { HiArrowNarrowRight } from "react-icons/hi";
import { useNavigate, Link } from "react-router-dom";
import  axios  from "axios";
import { API_BASE_URL } from "../../app_url";
import {NotificationManager} from 'react-notifications'; 


import { sendVerifyEmail, getUserDetails, getCurrency, getLanguages, completeStep1, getPurchasedProductList, getPageContent } from "../../api/apiRequest";
import { useLangContext } from "../../context/languageContext";

const LetStarted = () => {
  const navigate = useNavigate();
  const {hostLanguage,languageJson} = useLangContext();
  const [showAllLanguages,setShowAllLanguages] = useState([]);
  const [showAllCurrencies,setShowAllCurrencies] = useState([]);
  const [selectedLanguage,setSelectedLanguage] = useState();
  const [selectedCurrency,setSelectedCurrency] = useState();
  const [showError,setShowError] = useState(false);
  const [contentDetails,setContentDetails] = useState();

  const [loginData, setLoginData] = useState();
  const [userDetails, setUserDetails] = useState();
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  // let errors ={
  //   language: 'Please select a language',
  //   currency: 'Please select a currency'
  // }

  useEffect(() => {
    //CreateBroadcast();
    //let data = logInDetails();
    let value = JSON.parse(localStorage.getItem("virtualOfficeLoginInfo")); //JSON.parse(secureLocalStorage.getItem('loginInfo'));
    console.warn(value)
    getUserData();
    // PurchasedProductList();
  }, []);

  const PurchasedProductList = async() =>
  {
    try
    {
      let apiRes = await getPurchasedProductList();
      let responseData = await apiRes.json();
      if(responseData)
      { console.log(responseData.res);
        //setProductDetails(responseData.data)
        if(responseData.res==true){
          navigate("/Login");
        }
        //LetStarted
      }
      else
      {
        //NotificationManager.error(responseData.msg, '',2000);
      }
    }
    catch(error)
    {
      //NotificationManager.error('Something went wrong!', '',2000);
    }
  }

  // get page content
  const getAllPageContent = async() => {
    try
    {
      let apiRes = await  getPageContent(hostLanguage, "lets_start_page_data");
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setContentDetails(responseData.data);
        // console.warn(responseData.data.header);
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
      console.error(error);
    }
  }

  //get user details
  const getUserData = async() =>
  {
    try
    {
      let apiRes = await getUserDetails();
      let responseData = await apiRes.json();
      if(responseData)
      {
        setUserDetails(responseData.data)
      }
      else
      {
        NotificationManager.error(responseData.msg, '',2000);
      }
    }
    catch(error)
    {
      console.error('Something went wrong!', '',2000);
    }
  }


  //getting all languages
  const handleGetLanguages = async() =>
  {
    try
    {
      let apiRes = await getLanguages();
      let responseData = await apiRes.json();
      if(responseData)
      {
        setShowAllLanguages(responseData.data)
      }
      else
      {
        NotificationManager.error(responseData.msg, '',2000);
      }
    }
    catch(error)
    {
      NotificationManager.error('Something went wrong!', '',2000);
    }
  }

  //getting all currencies
  const handleGetCurrencies = async() =>
    {
      try
      {
        let apiRes = await getCurrency();
        let responseData = await apiRes.json();
        if(responseData)
        {
          setShowAllCurrencies(responseData.data)
        }
        else
        {
          NotificationManager.error(responseData.msg, '',2000);
        }
      }
      catch(error)
      {
        // NotificationManager.error('Something went wrong!', '',2000);
      }
  }

  // complete step1
  const handleCompleteStep1 = async() => {
    try
    {
      // if(selectedLanguage == undefined || selectedCurrency == undefined)
      if(selectedCurrency == undefined)
      {
        setShowError(true)
      }
      else
      {
        setShowError(false);
        // let apiRes = await completeStep1(selectedLanguage,selectedCurrency);
        let apiRes = await completeStep1(1,selectedCurrency,hostLanguage);
        let responseData = await apiRes.json();
        console.warn(responseData.res)
        if(responseData.res)
        {
          navigate("/SelectProduct");
        }
        else
        {
          NotificationManager.error(responseData.msg, '',2000);
        }
      }
    }
    catch(error)
    {
      // NotificationManager.error('Something went wrong!', '',2000);
    }
  }

  const handleVerifyEmail = async (e,type = "user") => {
    try
    {
      setLoading(true);
      setSent(false);
      e.preventDefault();

      let values = {email:userDetails.email}
      let apiRes = await sendVerifyEmail(values)
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setSent(true);
      }
    }
    catch(error)
    {
      console.error(error, '',2000);
      console.error('Something went wrong!', '',2000);
    }finally{
      setTimeout(()=>{ setLoading(false) }, 5000);
    }
  }

  useEffect(()=>{
    handleGetLanguages();
    handleGetCurrencies();
    getAllPageContent();
    console.warn(hostLanguage)
  },[hostLanguage])

  // working
  useEffect(() => {
    // Load Google Translate script dynamically
    const script = document.createElement('script');
    script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.async = true; // Set async attribute to true
    script.crossOrigin = "anonymous"
    document.body.appendChild(script);

    // Initialize Google Translate
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement({ pageLanguage: 'en' }, 'google_translate_element');
    };

    return () => {
      // Clean up function
      document.body.removeChild(script);
      delete window.googleTranslateElementInit;
    };
  }, []);

  return (
    <div className="lightBlue">
      <Header />

      {!userDetails?.email_verified_at ? (
        <>
          <div className="MainBody">
            <div className="container">
              <div className="container">
                <div className="FrmBody">
                  <Row className="align-items-center">
                    <Col sm={12} md={12}>
                      <h2 className="text-center p-0">{contentDetails?.lets_start_page_data?.activate_account}</h2>
                    </Col>
                    <Col sm={12} md={12}>
                      {contentDetails?.lets_start_page_data?.activate_account_desc}
                    </Col>
                    <Col sm={12} md={12}>
                      <Button
                        variant="primary"
                        type="submit"
                        className="LogBtn d-inline mt-4"
                        onClick={() => navigate("/Dashboard")}
                      >{contentDetails?.lets_start_page_data?.prouct_page_back_button}</Button>
                      {loading ? 
                        <Button
                          variant="primary"
                          type="submit"
                          className="BtnSubmit w-auto mt-4"
                          onClick={(e) => handleVerifyEmail(e)}
                          disabled
                        >{contentDetails?.lets_start_page_data?.resend_mail}</Button>
                      : (
                        <Button
                          variant="primary"
                          type="submit"
                          className="BtnSubmit w-auto mt-4"
                          onClick={(e) => handleVerifyEmail(e)}
                        >{contentDetails?.lets_start_page_data?.resend_mail}</Button>
                      )}
                    </Col>
                    {loading ? (
                      <Col sm={12} md={12} className="mt-5">
                        {contentDetails?.lets_start_page_data?.sent_mail}
                      </Col>
                    ) : (
                      <></>
                    )}
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="Hrbottom">
            <div className="container">
              <Row className="align-items-center">
                <Col sm={12} md={5}>
                  {/* <h2>Set up your account</h2> */}
                  <h2>{contentDetails?.lets_start_page_data?.set_up_your_account}</h2>
                </Col>
                <Col sm={12} md={7}>
                  <div class="form-steps">
                    <div class="form-steps__step form-steps__step--active">
                      <div class="form-steps__step-circle">
                        <span class="form-steps__step-number">01</span>
                      </div>
                      {/* <span class="form-step__step-name">Let's Started</span> */}
                      <span class="form-step__step-name">{contentDetails?.lets_start_page_data?.lets_started}</span>
                    </div>

                    <div class="form-steps__step form-steps__step--incomplete">
                      <div class="form-steps__step-circle">
                        <span class="form-steps__step-number">02</span>
                      </div>
                      {/* <span class="form-step__step-name">Select Product</span> */}
                      <span class="form-step__step-name">{contentDetails?.lets_start_page_data?.select_product}</span>
                    </div>

                    <div class="form-steps__step form-steps__step--incomplete">
                      <div class="form-steps__step-circle">
                        <span class="form-steps__step-number">03</span>
                      </div>
                      {/* <span class="form-step__step-name">Your Details</span> */}
                      <span class="form-step__step-name">{contentDetails?.lets_start_page_data?.your_details}</span>
                    </div>

                    <div class="form-steps__step form-steps__step--last">
                      <div class="form-steps__step-circle">
                        <span class="form-steps__step-number">04</span>
                      </div>
                      {/* <span class="form-step__step-name">Payment</span> */}
                      <span class="form-step__step-name">{contentDetails?.lets_start_page_data?.payment}</span>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="MainBody">
            <div className="container">
              <div className="FrmBody">
                <Row className="align-items-center">
                  <Col sm={12} md={6}>
                    <h2>
                      {/* Select your account currency This cannot be changed later! */}
                      {contentDetails?.lets_start_page_data?.euro_description}
                    </h2>
                  </Col>
                  <Col sm={12} md={6}>
                    <div className="check-div check-divRadio">
                      {showAllCurrencies?.map((item,index)=>{
                        return(
                        <div className="form-check mr-3">
                          <Form.Check type="radio" name='currency' 
                            aria-label="option 1" 
                            id={`flexCheckChecked${index}`} 
                            value={index + 1} 
                            onChange={(e)=>setSelectedCurrency(e.target.value)}
                          />
                          <Form.Label
                            className="form-check-label"
                            for={`flexCheckChecked${index}`}
                          >
                            {/* <img src={item?.currency=='Euro' ? euro : item?.currency=='US-Dollar' ? dollor : ''} className="checkImg" alt="Img" /> */}
                            <img src={item?.currency=='Euro' ? euro : item?.currency=='US-Dollar' ? dollor : item?.currency=='CHF' ? chf :  ''} className="checkImg" alt="Img" />
                            <h3>{item?.currency}</h3>
                            <p>
                              {/* {item?.details} */}
                              {contentDetails?.lets_start_page_data?.euro_text}
                            </p>
                          </Form.Label>
                        </div>
                        )
                      })}
                    </div>
                  </Col>
                </Row>
                {showError && selectedCurrency == undefined && <span className="error" style={{paddingLeft:'252px'}}>{languageJson.currencyValidation}</span>}
              </div>

              <div className="BtnBottom">
                <Button
                  variant="primary"
                  type="submit"
                  className="BtnSubmit"
                  onClick={() => handleCompleteStep1()}
                >
                  {/* Proceed  */}
                  {contentDetails?.lets_start_page_data?.proceed_button_text}
                <HiArrowNarrowRight />
                </Button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default LetStarted;
